var file_upload_viewer_default = {
  "fontElementMap": "_37dMb",
  "file_upload_container": "oNpDd",
  "file_upload_link": "TWGkQ",
  "file_upload_error_container": "Zykwt",
  "file_upload_file_info": "rNubG",
  "file_upload_type_icon": "jVbJF",
  "file_upload_status_icon_container": "vyFJ1",
  "file_upload_status_icon": "_9Lt-S",
  "file_upload_description": "gBEcT",
  "file_upload_name_container": "ZH62A",
  "file_upload_name": "IgQRa",
  "file_upload_extension": "Qxvxo",
  "file_loader_icon": "QSXw6",
  "file_upload_icon_frame": "JFw4V",
  "file_upload_icon_background": "_25dzX"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
